/* ============================================================
   GUIDED BY CROSS — INTERACTIONS
   Loaded once via theme.liquid. Handles all UI interactions.
   ============================================================ */

(function() {
  'use strict';

  // ============ CAROUSEL SCROLL ============
  window.gbcScrollCarousel = function(trackId, dir) {
    const track = document.getElementById(trackId);
    if (!track) return;
    const card = track.querySelector('.gbc-card, .sale-card');
    const amount = card ? (card.getBoundingClientRect().width + 20) * 2 : 600;
    track.scrollBy({ left: amount * dir, behavior: 'smooth' });
  };

  function updateCarouselBtns(track) {
    const prev = document.querySelector(`[data-carousel-prev="${track.id}"]`);
    const next = document.querySelector(`[data-carousel-next="${track.id}"]`);
    if (!prev || !next) return;
    const max = track.scrollWidth - track.clientWidth;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max - 2;
  }

  document.querySelectorAll('.gbc-carousel-track').forEach(track => {
    track.addEventListener('scroll', () => updateCarouselBtns(track), { passive: true });
    updateCarouselBtns(track);
  });
  window.addEventListener('resize', () => {
    document.querySelectorAll('.gbc-carousel-track').forEach(updateCarouselBtns);
  });

  // ============ HERO SLIDESHOW ============
  document.querySelectorAll('[data-hero-slideshow]').forEach(hero => {
    const slides = hero.querySelectorAll('[data-hero-slide]');
    const dots = hero.querySelectorAll('[data-hero-dot]');
    const pauseBtn = hero.querySelector('[data-hero-pause]');
    if (slides.length < 2) return;

    let current = 0;
    let timer = null;
    let paused = false;
    const autoplay = parseInt(hero.dataset.autoplay || '8000', 10);

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach((s, idx) => s.classList.toggle('is-active', idx === current));
      dots.forEach((d, idx) => {
        d.classList.remove('is-active');
        if (idx === current) {
          void d.offsetWidth;
          d.classList.add('is-active');
        }
      });
    }
    function next() { show(current + 1); }
    function prev() { show(current - 1); }
    function restart() {
      clearInterval(timer);
      if (!paused) timer = setInterval(next, autoplay);
    }
    function togglePause() {
      paused = !paused;
      if (pauseBtn) {
        pauseBtn.querySelector('svg').innerHTML = paused
          ? '<path d="M8 5v14l11-7z" fill="currentColor"/>'
          : '<rect x="6" y="5" width="4" height="14" fill="currentColor"/><rect x="14" y="5" width="4" height="14" fill="currentColor"/>';
      }
      hero.classList.toggle('is-paused', paused);
      restart();
    }

    dots.forEach((d, i) => d.addEventListener('click', () => { show(i); restart(); }));
    const prevBtn = hero.querySelector('[data-hero-prev]');
    const nextBtn = hero.querySelector('[data-hero-next]');
    if (prevBtn) prevBtn.addEventListener('click', () => { prev(); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { next(); restart(); });
    if (pauseBtn) pauseBtn.addEventListener('click', togglePause);

    // Touch swipe
    let startX = 0;
    hero.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) { diff > 0 ? next() : prev(); restart(); }
    }, { passive: true });

    restart();
  });

  // ============ MEGA MENUS (desktop) ============
  const megaButtons = document.querySelectorAll('[data-megamenu]');
  const megaMenus = document.querySelectorAll('.gbc-megamenu');
  let megaTimer;

  megaButtons.forEach(btn => {
    btn.addEventListener('mouseenter', () => {
      clearTimeout(megaTimer);
      megaMenus.forEach(m => m.classList.remove('is-active'));
      const target = document.getElementById(`megamenu-${btn.dataset.megamenu}`);
      if (target) target.classList.add('is-active');
    });
  });

  const header = document.querySelector('.gbc-header');
  if (header) {
    header.addEventListener('mouseleave', () => {
      megaTimer = setTimeout(() => megaMenus.forEach(m => m.classList.remove('is-active')), 120);
    });
  }
  megaMenus.forEach(m => {
    m.addEventListener('mouseenter', () => clearTimeout(megaTimer));
    m.addEventListener('mouseleave', () => {
      megaTimer = setTimeout(() => m.classList.remove('is-active'), 120);
    });
  });

  // ============ MOBILE NAV ============
  window.gbcToggleMobileNav = function() {
    const nav = document.getElementById('mobileNav');
    if (!nav) return;
    nav.classList.toggle('is-active');
    document.body.style.overflow = nav.classList.contains('is-active') ? 'hidden' : '';
  };

  // ============ CART DRAWER ============
  window.gbcToggleCart = function() {
    const overlay = document.getElementById('cartOverlay');
    const drawer = document.getElementById('cartDrawer');
    if (!overlay || !drawer) return;
    overlay.classList.toggle('is-active');
    drawer.classList.toggle('is-active');
    document.body.style.overflow = drawer.classList.contains('is-active') ? 'hidden' : '';
  };

  // ============ HEADER SCROLL EFFECT ============
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('is-scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  // ============ WISHLIST + QUICK ADD ============
  window.gbcToggleWishlist = function(btn, e) {
    if (e) e.stopPropagation();
    btn.classList.toggle('is-active');
    gbcToast(btn.classList.contains('is-active') ? 'Saved to wishlist' : 'Removed');
  };

  window.gbcQuickAdd = function(variantId, name, e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(r => r.json())
    .then(() => {
      gbcToast(`${name.length > 30 ? name.slice(0, 30) + '…' : name} added`);
      updateCartBadge();
    })
    .catch(() => gbcToast('Something went wrong'));
  };

  function updateCartBadge() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const badge = document.querySelector('.gbc-cart-badge');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? '' : 'none';
        }
      });
  }

  // ============ TOAST ============
  let toastTimer;
  window.gbcToast = function(msg) {
    let t = document.getElementById('gbcToast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'gbcToast';
      t.className = 'gbc-toast';
      t.innerHTML = '<svg viewBox="0 0 24 24"><path d="M5 12l5 5L20 7"/></svg><span></span>';
      document.body.appendChild(t);
    }
    t.querySelector('span').textContent = msg;
    t.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-show'), 2200);
  };

  // ============ FADE IN ON SCROLL ============
  const fadeObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        fadeObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });
  document.querySelectorAll('.gbc-fade-in').forEach(el => fadeObserver.observe(el));

  // ============ MONSTER CART QUICK-ADD ============
  // Creates a hidden form + submits it — Monster Cart intercepts native form submissions reliably
  window.gbcMonsterAdd = function(variantId, name, e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    var btn = e ? e.currentTarget : null;
    if (btn) { btn.textContent = '...'; btn.style.opacity = '0.7'; }

    // Try native fetch first, dispatch Monster Cart events
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      if (btn) { btn.textContent = 'Added ✓'; setTimeout(function(){ btn.textContent = 'Quick Add'; btn.style.opacity = ''; }, 1400); }
      // Fire every known Monster Cart trigger event
      ['cart:refresh', 'cart:updated', 'cart:add', 'monster-cart:open',
       'theme:cart:open', 'cartUpdated'].forEach(function(evt) {
        document.dispatchEvent(new CustomEvent(evt, { bubbles: true, detail: { variantId: variantId } }));
        window.dispatchEvent(new CustomEvent(evt, { bubbles: true }));
      });
      syncCartBadge();
    })
    .catch(function() {
      if (btn) { btn.textContent = 'Quick Add'; btn.style.opacity = ''; }
    });
  };
  function syncCartBadge() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var badge = document.querySelector('.gbc-cart-badge');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? '' : 'none';
        }
      }).catch(function() {});
  }
  // Sync on page load
  syncCartBadge();
  // Sync when tab regains focus (catches Monster Cart updates from other tabs)
  window.addEventListener('focus', syncCartBadge);
  // Sync after any click on an add-to-cart button (catches Monster Cart's own buttons)
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[name="add"], .add-to-cart, [data-add-to-cart], .product-form__submit');
    if (btn) setTimeout(syncCartBadge, 1200);
  });
  // Listen for Monster Cart's cart update event
  document.addEventListener('cart:updated', syncCartBadge);
  document.addEventListener('cart:refresh', syncCartBadge);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      const cart = document.getElementById('cartDrawer');
      const mobile = document.getElementById('mobileNav');
      const searchForm = document.getElementById('gbcSearchForm');
      const header = document.getElementById('gbcHeader');
      if (cart && cart.classList.contains('is-active')) gbcToggleCart();
      if (mobile && mobile.classList.contains('is-active')) gbcToggleMobileNav();
      if (searchForm && searchForm.classList.contains('is-open')) {
        searchForm.classList.remove('is-open');
        
      }
    }
  });

  // ============ SEARCH TOGGLE ============
  window.gbcToggleSearch = function() {
    var form = document.getElementById('gbcSearchForm');
    var input = document.getElementById('gbcSearchInput');
    var header = document.getElementById('gbcHeader');
    if (!form) return;
    var opening = !form.classList.contains('is-open');
    form.classList.toggle('is-open');
    
    if (opening && input) setTimeout(function() { input.focus(); }, 350);
  };

  // Close search when clicking outside the search wrap
  document.addEventListener('click', function(e) {
    var form = document.getElementById('gbcSearchForm');
    var header = document.getElementById('gbcHeader');
    if (!form || !form.classList.contains('is-open')) return;
    var wrap = form.closest('.gbc-search-wrap');
    if (wrap && !wrap.contains(e.target)) {
      form.classList.remove('is-open');
      
    }
  });
})();